import { RECOMMENDED_PRICE_MARGIN } from '@gelato-api-ui/core/e-commerce/constants';
import { toPriceNumber } from '@gelato-api-ui/core/product-prices/helpers/toPriceNumber';

export const calculateRecommendedPrice = (cost: number): number => toPriceNumber(cost * RECOMMENDED_PRICE_MARGIN);
